import styled from "styled-components";
import { V3HeadlineH3, V3Paragraph } from "../Typography";

export const FakeProfileSetSelectWrapper = styled.div<{$isOption: boolean}>`
    background: ${({ theme, $isOption }) =>  !$isOption ? theme.v3.colors.grey96 : undefined};
    padding: ${({ $isOption }) =>  !$isOption ? "14px 22px" : "12px 8px"};
    line-height: 20px;
    border-radius: 8px;
    min-width: 300px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    cursor: pointer;

    &:hover {
        background: ${({ theme }) => theme ? theme.v3.colors.grey88 : undefined};
    }

    > div {
        &:first-child {
            margin-right: 40px;
        }
    }
`;



export const FakeProfileFontSetHeading = styled(V3HeadlineH3).attrs<{$fontFamily: string}>(
    ({ $fontFamily }) => ({
        style: {
            fontFamily:  $fontFamily
        },
    })
) <{$isOption: boolean}>`
    line-height: 15px;
    font-size: 16px;
`;

export const FakeProfileFontSetParagraph = styled(V3Paragraph).attrs<{$fontFamily: string}>(
    ({ $fontFamily }) => ({
        style: {
            fontFamily:  $fontFamily
        },
    })
)<{$isOption: boolean}>`
    line-height: 14px;
    font-size: 15px;
    margin-top: 6px;
`;